import { MdCheck, MdLink } from 'react-icons/md';
import { toast } from 'react-toastify';
import { getPlanSlug } from '../../utils/planSlug';
import {
  Benefit,
  BenefitsContainer,
  CardContainer,
  CopyLinkButton,
  Footer,
  FooterSubtext,
  FooterText,
  Price,
} from './styles';

/*
  interface Props {
    plan: {
      id: string;
      identifier: string;
      is_visible: boolean;
      name: string;
      price: string; // Ex: "1.00"
      type: string; // 'mensal' | 'anual';
    }
    setSelectedPlan: (id: string) => void;
    selectedPlan: string;
  }
*/
const NewPlanCard = ({
  plan,
  selectedPlan = '',
  setSelectedPlan = () => {},
  onSelectPlan = () => {},
}) => {
  const formatStringCurrency = (value) => {
    const parsedValue = parseFloat(value);

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format;

    return formatter(parsedValue);
  };

  const handleSelectedPlan = (id) => {
    localStorage.setItem('YogaCO@ChoosedPlan', id);
    setSelectedPlan(id);
    onSelectPlan(plan);
  };

  const handleCopyLink = async (event, planToCopy) => {
    event.stopPropagation();

    const slug = getPlanSlug(planToCopy.name);
    const link = `${window.location.origin}${window.location.pathname}#/cadastro?plano=${encodeURIComponent(slug)}`;

    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link do plano copiado!');
    } catch (error) {
      toast.error('Não foi possível copiar o link');
    }
  };

  const timePeriod = plan.name === 'Plano Anual' ? '/ano' : '/mês';

  // const planType = plan.name === 'Plano Anual' ? 'Anual' : 'Individual';

  return (
    <CardContainer
      onClick={() => handleSelectedPlan(plan.id)}
      isSelected={selectedPlan === plan.id}
    >
      <Price>
        {formatStringCurrency(plan.price)}
        <small>{timePeriod}</small>
      </Price>
      <BenefitsContainer>
        <Benefit>
          <MdCheck />
          <p>Tenha acesso ilimitado ao App</p>
        </Benefit>
        <Benefit>
          <MdCheck />
          <p>Aprenda no seu tempo</p>
        </Benefit>
        <Benefit>
          <MdCheck />
          <p>Se desenvolva com qualidade</p>
        </Benefit>
      </BenefitsContainer>
      <Footer>
        <CopyLinkButton
          role="button"
          tabIndex={0}
          title="Copiar link deste plano"
          onClick={(event) => handleCopyLink(event, plan)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              handleCopyLink(event, plan);
            }
          }}
        >
          <MdLink />
        </CopyLinkButton>
        <FooterSubtext>PLANO</FooterSubtext>
        <FooterText>{plan.name.replace('Plano ', "")}</FooterText>
      </Footer>
    </CardContainer>
  );
};

export default NewPlanCard;
